import React, { useState } from "react";

const views = [
  {
    title: "Find the focus",
    heading: "A place to start.",
    body: "Go from the course overview to an area worth a closer look.",
    badge: "Inspection suggested",
    cardTitle: "West approach",
    cardBody: "A change in this area is worth checking on the ground.",
    status: "Review with your course team",
    label: "Area to inspect",
  },
  {
    title: "Record the work",
    heading: "Keep the context.",
    body: "Connect the observation, the place and the work your team records.",
    badge: "Action record",
    cardTitle: "Follow up the approach",
    cardBody:
      "Walk the flagged area and add an observation before deciding on maintenance.",
    status: "Status: planned",
    label: "Inspection location",
  },
  {
    title: "Follow the change",
    heading: "Return to the evidence.",
    body: "Compare the same ground across survey dates and review what changed.",
    badge: "Survey comparison",
    cardTitle: "The same ground. Two dates.",
    cardBody:
      "Read the observations alongside the work record. Change alone does not prove a treatment caused it.",
    status: "Earlier survey / later survey",
    label: "Comparison area",
  },
];

function CourseDrawing({ selected }) {
  const trees = Array.from({ length: 90 }, (_, i) => ({
    x: 18 + ((i * 137) % 865),
    y: 24 + ((i * 83) % 425),
    r: 6 + (i % 4) * 2,
  }));
  return (
    <svg
      className="course-drawing"
      viewBox="0 0 900 470"
      fill="none"
      aria-hidden="true"
    >
      <rect width="900" height="470" fill="#203d32" />
      <path
        d="M-30 330C100 242 146 445 285 367S450 355 494 447M650-40c-75 102 76 109 4 230S807 325 941 239"
        stroke="#294a3b"
        strokeWidth="95"
      />
      {trees.map((t, i) => (
        <circle
          key={i}
          cx={t.x}
          cy={t.y}
          r={t.r}
          fill={i % 2 ? "#294838" : "#355540"}
          opacity=".7"
        />
      ))}
      <g stroke="#506849" strokeWidth="1" opacity=".45">
        <path d="M-10 75C160 120 80 12 277 54S379 208 569 157 742 7 923 65" />
        <path d="M-10 86C164 134 87 20 275 66S381 219 572 169 755 21 921 79" />
        <path d="M-10 100C164 149 91 32 279 80S384 234 581 181 754 37 927 92" />
        <path d="M-10 416C125 308 181 421 336 369S563 480 705 385 799 402 930 342" />
        <path d="M-10 433C125 322 181 435 336 383S563 494 712 401 802 417 930 357" />
        <path d="M-10 446C125 339 185 449 339 396S563 509 712 416 802 432 930 373" />
      </g>
      <path
        d="M91 506C74 431 162 408 161 346S108 244 174 211 243 222 264 156 226 68 301-24"
        stroke="#849d99"
        strokeWidth="23"
        opacity=".7"
      />
      <path
        d="M91 506C74 431 162 408 161 346S108 244 174 211 243 222 264 156 226 68 301-24"
        stroke="#a0b3a7"
        strokeWidth="2"
        opacity=".5"
      />
      <g fill="#6f8755" stroke="#a1ad77" strokeWidth="1.5">
        <path d="M52 57C18 93 57 115 102 122L245 173C284 187 302 155 273 137L130 91C97 80 102 28 52 57Z" />
        <path d="M344 52C313 29 283 63 305 91L438 213C469 244 517 221 492 192L392 113C370 94 376 75 344 52Z" />
        <path d="M535 47C488 16 464 49 498 89L600 199C620 234 660 236 677 210C703 177 647 160 626 135L535 47Z" />
        <path d="M779 66C749 36 718 62 735 99L795 219C815 259 869 247 856 209L799 128C787 106 798 83 779 66Z" />
        <path d="M789 304C808 270 770 247 743 275L631 361C608 378 579 387 592 412C611 446 651 411 681 390L789 304Z" />
        <path d="M492 319C525 291 497 261 463 275L323 313C291 320 257 306 243 334C223 374 265 387 302 368L492 319Z" />
        <path d="M68 265C28 247 20 282 50 309L87 375C112 417 149 389 129 357L97 304C89 288 90 278 68 265Z" />
      </g>
      <g fill="#99aa72">
        <ellipse
          cx="62"
          cy="79"
          rx="22"
          ry="17"
          transform="rotate(-25 62 79)"
        />
        <ellipse
          cx="327"
          cy="67"
          rx="22"
          ry="16"
          transform="rotate(36 327 67)"
        />
        <ellipse
          cx="517"
          cy="64"
          rx="23"
          ry="16"
          transform="rotate(39 517 64)"
        />
        <ellipse cx="762" cy="81" rx="19" ry="23" />
        <ellipse
          cx="771"
          cy="295"
          rx="21"
          ry="16"
          transform="rotate(-30 771 295)"
        />
        <ellipse cx="475" cy="295" rx="22" ry="17" />
        <ellipse cx="58" cy="284" rx="20" ry="16" />
      </g>
      <g fill="#d3caae">
        <path d="M71 49c19-10 34 10 25 20-8 8-12-13-25-12-9 0-9-4 0-8Z" />
        <path d="M347 59c17-2 22 17 14 24-6 5-4-12-13-15-7-3-9-8-1-9Z" />
        <path d="M493 279c14-7 27 10 20 18-7 7-7-9-18-10-8-1-8-5-2-8Z" />
        <path d="M746 58c-13-6-22 10-14 19 6 6 3-9 15-11 6-2 6-5-1-8Z" />
      </g>
      <path
        d="M123 120C204 131 281 109 353 150S414 254 534 248 717 282 850 339"
        stroke="#c1c9b0"
        strokeWidth="2"
        strokeDasharray="4 6"
        opacity=".6"
      />
      <g>
        <path
          d="M360 303 420 286 449 310 392 334 357 322Z"
          fill={selected === 2 ? "#c7b86b" : "#dfb56e"}
          fillOpacity=".85"
          stroke="#f3d5a0"
          strokeWidth="2"
        />
        <path
          d="m367 306 24 23m-7-30 25 22m-6-28 24 22m-65 0 70-22m-53 31 65-24"
          stroke="#f5e3ba"
          strokeWidth=".8"
          opacity=".65"
        />
        <circle
          cx="410"
          cy="307"
          r="38"
          stroke="#f5e3ba"
          strokeDasharray="3 5"
          opacity=".6"
        />
      </g>
      {selected === 2 && (
        <g>
          <path d="M406 262V357" stroke="#f5f4e9" strokeWidth="2" />
          <circle cx="406" cy="343" r="12" fill="#f5f4e9" />
          <path
            d="m402 339-4 4 4 4m8-8 4 4-4 4"
            stroke="#203d32"
            strokeWidth="1.5"
          />
        </g>
      )}
      <g
        fontFamily="Arial, sans-serif"
        fontSize="11"
        textAnchor="middle"
        fill="#ecebda"
      >
        {[
          [241, 148, "01"],
          [454, 194, "02"],
          [628, 192, "03"],
          [816, 209, "04"],
          [623, 400, "05"],
          [275, 344, "07"],
          [107, 372, "08"],
        ].map(([x, y, label]) => (
          <g key={label}>
            <circle cx={x} cy={y} r="13" fill="#284330" stroke="#93a37d" />
            <text x={x} y={y + 4}>
              {label}
            </text>
          </g>
        ))}
      </g>
    </svg>
  );
}

export default function ProductPreview() {
  const [selected, setSelected] = useState(0);
  const view = views[selected];
  const handleKeys = (event, index) => {
    let next;
    if (event.key === "ArrowRight") next = (index + 1) % views.length;
    if (event.key === "ArrowLeft")
      next = (index + views.length - 1) % views.length;
    if (event.key === "Home") next = 0;
    if (event.key === "End") next = views.length - 1;
    if (next !== undefined) {
      event.preventDefault();
      setSelected(next);
      document.getElementById(`preview-tab-${next}`).focus();
    }
  };
  return (
    <div className="product-preview" id="product">
      <div className="preview-topline">
        <span>
          <span className="small-mark">v</span> Your course, in context
        </span>
        <span className="example-label">
          Illustrative product view · example data
        </span>
      </div>
      <div
        className="preview-window"
        role="tabpanel"
        id="preview-panel"
        aria-labelledby={`preview-tab-${selected}`}
      >
        <aside className="preview-sidebar">
          <span className="eyebrow">Survey workspace</span>
          <div className="sidebar-course">
            Course overview <span>↗</span>
          </div>
          <div className="workspace-nav">
            <span className="active-workspace">
              Overview <span>01</span>
            </span>
            <span>Insights</span>
            <span>Actions</span>
            <span>Compare</span>
          </div>
          <div className="sidebar-bottom">
            <span className="tiny-dot" /> Published survey
            <br />
            <small>A shared view for your team</small>
          </div>
        </aside>
        <div className={`preview-map state-${selected}`}>
          <CourseDrawing selected={selected} />
          <div className="map-title">
            <span>Hole 07</span>
            <strong>West approach</strong>
          </div>
          <span className="north-marker">
            N<span>↑</span>
          </span>
          <div className="map-pin">
            <span className="pin-centre">{selected === 1 ? "✓" : "+"}</span>
            <span>{view.label}</span>
          </div>
          <div className="finding-card" key={selected}>
            <span className="finding-kicker">
              <span className="tiny-dot" />
              {view.badge}
            </span>
            <strong>{view.cardTitle}</strong>
            <p>{view.cardBody}</p>
            <div className="finding-footer">
              {view.status}
              <span>↗</span>
            </div>
          </div>
          <div className="map-caption">
            <span className="map-scale" /> Schematic course view
          </div>
        </div>
      </div>
      <div
        className="preview-controls"
        role="tablist"
        aria-label="Explore the course workflow"
      >
        {views.map((item, index) => (
          <button
            key={item.title}
            role="tab"
            id={`preview-tab-${index}`}
            aria-controls="preview-panel"
            aria-selected={selected === index}
            tabIndex={selected === index ? 0 : -1}
            onKeyDown={(event) => handleKeys(event, index)}
            onClick={() => setSelected(index)}
          >
            <span className="step-number">0{index + 1}</span>
            <span>{item.title}</span>
            <span className="tab-arrow">↗</span>
          </button>
        ))}
      </div>
      <div className="preview-description" aria-live="polite">
        <strong>{view.heading}</strong>
        <span>{view.body}</span>
      </div>
    </div>
  );
}
